/* Layout */
import Layout from '../../views/layout/Layout.vue'

const HomeCollections = () => import(/* webpackChunkName: "home-collections" */ '@/views/home/HomeCollections')

export default [
  {
    path: '/home-collections',
    component: Layout,
    redirect: 'noredirect',
    name: 'HomeCollections',
    alwaysShow: true,
    meta: {
      title: 'homeCollections',
      icon: 'home',
    },
    children: [
      {
        path: 'home',
        component: HomeCollections,
        name: 'HomeCollectionsHome',
        props: { slug: 'home' },
        meta: {
          title: 'home',
          accessibleName: 'home-collections',
        },
      },
      {
        path: 'fashion',
        component: HomeCollections,
        name: 'HomeCollectionsFashion',
        props: { slug: 'fashion' },
        meta: {
          title: 'fashion',
          accessibleName: 'home-collections',
        },
      },
      {
        path: 'kids',
        component: HomeCollections,
        name: 'HomeCollectionsKids',
        props: { slug: 'kids' },
        meta: {
          title: 'kids',
          accessibleName: 'home-collections',
        },
      },
      {
        path: 'beauty',
        component: HomeCollections,
        name: 'HomeCollectionsBeauty',
        props: { slug: 'beauty' },
        meta: {
          title: 'beauty',
          accessibleName: 'home-collections',
        },
      },
      {
        path: 'bags',
        component: HomeCollections,
        name: 'HomeCollectionsBags',
        props: { slug: 'bags' },
        meta: {
          title: 'bags',
          accessibleName: 'home-collections',
        },
      },
      {
        path: 'shoes',
        component: HomeCollections,
        name: 'HomeCollectionsShoes',
        props: { slug: 'shoes' },
        meta: {
          title: 'shoes',
          accessibleName: 'home-collections',
        },
      },
      {
        path: 'lifestyle',
        component: HomeCollections,
        name: 'HomeCollectionsLifestyle',
        props: { slug: 'lifestyle' },
        meta: {
          title: 'lifestyle',
          accessibleName: 'home-collections',
        },
      },
      {
        path: 'preview',
        component: HomeCollections,
        name: 'HomeCollectionsPreview',
        props: { slug: 'preview' },
        meta: {
          title: 'preview',
          accessibleName: 'home-collections',
        },
      },
    ],
  },
]
